import React from 'react';
import PropTypes from 'prop-types';

import {Stack, TextField, Dropdown, DropdownMenuItem} from 'views/components';
import {translate} from 'views/module';

const ContactEdit = (props) => {
  const {bioQuestions, fields, setFields} = props;

  React.useEffect(() => {
    const fields = {
      firstName: bioQuestions.firstName || '',
      lastName: bioQuestions.lastName || '',
      email: bioQuestions.email || '',
      phoneNumber: bioQuestions.phoneNumber || '',
      streetAddress: bioQuestions.streetAddress || '',
      city: bioQuestions.city || '',
      province: bioQuestions.province || '',
      postalCode: bioQuestions.postalCode || '',
    };
    setFields(fields);
  }, [bioQuestions]);

  const handleChange = (field) => (value) => {
    setFields((prev) => ({...prev, [field]: value}));
  };

  const provinces = Object.entries(translate('caregiver.CaregiverBiography.Contact.Province.List'))
      .map(([code, label]) => ({value: code, label: label}));

  return (
    <Stack spacing={2}>
      <Stack
        direction={{md: 'row', xs: 'column'}}
        spacing={2}
      >
        <TextField
          label={translate('caregiver.CaregiverBiography.Contact.FirstName.Label')}
          value={fields.firstName || ''}
          onChange={handleChange('firstName')}
          fullWidth
        />
        <TextField
          label={translate('caregiver.CaregiverBiography.Contact.LastName.Label')}
          value={fields.lastName || ''}
          onChange={handleChange('lastName')}
          fullWidth
        />
      </Stack>
      <TextField
        label={translate('caregiver.CaregiverBiography.Contact.Email.Label')}
        value={fields.email || ''}
        onChange={handleChange('email')}
      />
      <TextField
        label={translate('caregiver.CaregiverBiography.Contact.PhoneNumber.Label')}
        value={fields.phoneNumber || ''}
        onChange={handleChange('phoneNumber')}
      />
      <TextField
        label={translate('caregiver.CaregiverBiography.Contact.StreetAddress.Label')}
        value={fields.streetAddress || ''}
        onChange={handleChange('streetAddress')}
      />
      <Stack
        direction={{md: 'row', xs: 'column'}}
        spacing={2}
      >
        <TextField
          label={translate('caregiver.CaregiverBiography.Contact.City.Label')}
          value={fields.city || ''}
          onChange={handleChange('city')}
          fullWidth
        />
        <Dropdown
          label={translate('caregiver.CaregiverBiography.Contact.Province.Label')}
          value={fields.province || ''}
          onChange={handleChange('province')}
          variant={'outlined'}
          fullWidth
        >
          {
            provinces.map((province) => (
              <DropdownMenuItem key={province.value} value={province.value}>
                {province.label}
              </DropdownMenuItem>
            ))
          }
        </Dropdown>
        <TextField
          label={translate('caregiver.CaregiverBiography.Contact.PostalCode.Label')}
          value={fields.postalCode || ''}
          onChange={handleChange('postalCode')}
          fullWidth
        />
      </Stack>
    </Stack>
  );
};

ContactEdit.propTypes = {
  bioQuestions: PropTypes.object.isRequired,
  fields: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    streetAddress: PropTypes.string,
    city: PropTypes.string,
    province: PropTypes.string,
    postalCode: PropTypes.string,
  }).isRequired,
  setFields: PropTypes.func.isRequired,
};

export default React.memo(ContactEdit);
